/* eslint-disable */
export enum EarnType {
    lending = "lending",
    staking = "staking",
    defi = "defi",
    nodes = "nodes",
}
